import { senderBackSuppressErrorToast } from './sender-back-request';
import { api } from './http';

export type SenderAutoCampaignView = {
	id: string | null;
	status: 'stopped' | 'running';
	presetIds: string[];
	queuePending: number;
	queueRunning: number;
	queueDone: number;
	queueFailed: number;
	startedAt: string | null;
	stoppedAt: string | null;
};

export async function fetchSenderAutoCampaign() {
	const { data } = await api.get<SenderAutoCampaignView>('/sender/auto-campaign');
	return data;
}

export async function upsertSenderAutoCampaign(body: { presetIds: string[] }) {
	const { data } = await api.post<SenderAutoCampaignView>(
		'/sender/auto-campaign',
		body,
		senderBackSuppressErrorToast,
	);
	return data;
}

export async function startSenderAutoCampaign() {
	const { data } = await api.post<SenderAutoCampaignView>(
		'/sender/auto-campaign/start',
		undefined,
		senderBackSuppressErrorToast,
	);
	return data;
}

export async function stopSenderAutoCampaign() {
	const { data } = await api.post<SenderAutoCampaignView>(
		'/sender/auto-campaign/stop',
		undefined,
		senderBackSuppressErrorToast,
	);
	return data;
}
